import { normalize, schema } from 'normalizr';

export const entity = 'customerModules';
export const entitySchema = new schema.Entity(entity);
export const normalizer = (result) => normalize(result.modules, entitySchema);
export const listNormalizer = (result) => normalize(result.customer_modules, [entitySchema]);
